<template>
    <div
        class="px-8 pt-6 pb-8 rounded-lg border bg-slate-50 border-slate-200 relative"
    >
        <ArrowIcon />
        <div class="flex items-center justify-between mb-4">
            <h2 class="text-xl lg:text-2xl font-medium text-slate-800">
                Your Trip
            </h2>
            <button
                v-if="userTrip"
                type="button"
                class="flex items-center gap-2 font-medium px-4 py-2 text-slate-700 hover:text-slate-400 transition-colors"
                @click="emit('changeTrip')"
            >
                <Icon icon="refresh" class="w-5 h-5 text-slate-500" />
                Change
            </button>
        </div>

        <div
            class="h-0.5 mb-7 self-stretch [background:linear-gradient(90deg,rgba(226,232,240,0.50)_0%,#E2E8F0_4.94%,#E2E8F0_94.46%,rgba(226,232,240,0.50)_100%)]"
        ></div>

        <div v-if="userTrip">
            <img
                :src="userTrip?.imageUrl"
                alt="Your Trip"
                class="w-full h-64 object-cover rounded-lg"
            />

            <div class="py-6">
                <TripHeader class="mb-6" :trip="userTrip" />
                <Redemptions :redemptions="userTrip?.redemptions" />
            </div>
        </div>
        <div v-else class="p-6">
            <EmptyState
                icon="alert"
                title="No Trips to Swap"
                description="It looks like you don't have any trips added in your Redemption Tracker. Please add some trips there first, and then you may swap trips."
                action-label="Add a Trip"
                container-styles="py-10 h-full flex items-center text-center justify-center"
                @action="gotoRedemptionTracker"
            />
        </div>
    </div>
</template>
<script setup>
import TripHeader from '@/components/trip-swap/trip-header.vue';
import Icon from '@/components/ui/icon/icon.vue';
import Redemptions from '@/components/trip-swap/redemptions.vue';
import ArrowIcon from '@/components/trip-swap/arrow-icon.vue';
import EmptyState from '@/components/ui/empty-state/empty-state.vue';
const { userTrip } = defineProps(['userTrip']);
const emit = defineEmits(['changeTrip']);

const gotoRedemptionTracker = () => {
    window.location.href = '/trips';
};
</script>
